import MultiSwitchConnector from '@src/sld/components/MultiSwitchConnector/MultiSwitchConnector';
import BreakerStack1 from '@src/sld/sagebrush/sagebrush_b59/components/BreakerStack1';
import BreakerStack2 from '@src/sld/sagebrush/sagebrush_b59/components/BreakerStack2';
import TopSwitchResistorSection from '@src/sld/sagebrush/sagebrush_b59/components/TopSwitchResistorSection';
import storeConnector from '@store/storeConnector';
import { ReactElement } from 'react';
import Switch1Units from './components/Switch1Units';
import Switch2Units from './components/Switch2Units';
import Switch3Units from './components/Switch3Units';
import UnitProvider from './components/UnitContext';

function SageBrushB59Diagram(): ReactElement {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xlinkHref='http://www.w3.org/1999/xlink'
      viewBox='125 25 1300 645'
      xmlSpace='preserve'
      colorInterpolationFilters='sRGB'
      className='st10'
      style={{ fill: 'none', stroke: 'currentColor', overflowX: 'auto' }}
    >
      <title>Sagebrush B59</title>

      <TopSwitchResistorSection
        translateXCoordinate={-125}
        translateYCoordinate={-20}
      />
      <UnitProvider>
        <Switch1Units />
        <Switch2Units />
        <Switch3Units />
      </UnitProvider>

      <MultiSwitchConnector
        translateXCoordinate={240}
        translateYCoordinate={-250}
        verticalLength={20}
        horizontalLength={260}
        startingXCoordinate={410}
      />
      <MultiSwitchConnector
        translateXCoordinate={75.5}
        translateYCoordinate={-392}
        verticalLength={31}
        horizontalLength={427}
        startingXCoordinate={285}
      />
      <BreakerStack1 />
      <BreakerStack2 />
    </svg>
  );
}

export default storeConnector(SageBrushB59Diagram, {
  config: ['siteMeta'],
});
